module.exports = __webpack_public_path__ + "img/mobilenewsLogo9.04fd8f06.png";